import { render, staticRenderFns } from "./MdOverlay.vue?vue&type=template&id=384a79fc"
import script from "./MdOverlay.vue?vue&type=script&lang=js"
export * from "./MdOverlay.vue?vue&type=script&lang=js"
import style0 from "./MdOverlay.vue?vue&type=style&index=0&id=384a79fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports